import { render, staticRenderFns } from "./box_1.vue?vue&type=template&id=dd17da22&scoped=true&"
import script from "./box_1.vue?vue&type=script&lang=js&"
export * from "./box_1.vue?vue&type=script&lang=js&"
import style0 from "./box_1.vue?vue&type=style&index=0&id=dd17da22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd17da22",
  null
  
)

export default component.exports